import type Phaser from "phaser";
import type { PairData } from "../types";

export default class MonsterGirl {
  public sprite: Phaser.GameObjects.Sprite;
  private idleTimer?: Phaser.Time.TimerEvent;
  private idleFlip = false;

  constructor(
    private scene: Phaser.Scene,
    x: number,
    y: number,
    public readonly pair: PairData,
  ) {
    this.sprite = scene.add.sprite(x, y, pair.girlKeys.idle1).setOrigin(0.5, 1.0);
    this.startIdle();
  }

  setDepth(d: number): this {
    this.sprite.setDepth(d);
    return this;
  }

  startIdle(): void {
    this.stopIdle();
    this.sprite.setTexture(this.pair.girlKeys.idle1);
    this.idleFlip = false;
    this.idleTimer = this.scene.time.addEvent({
      delay: 600,
      loop: true,
      callback: () => {
        this.idleFlip = !this.idleFlip;
        this.sprite.setTexture(this.idleFlip ? this.pair.girlKeys.idle2 : this.pair.girlKeys.idle1);
      },
    });
  }

  stopIdle(): void {
    this.idleTimer?.remove();
    this.idleTimer = undefined;
  }

  /** Поза приказа: указывает пальцем вниз. */
  playCommand(): Promise<void> {
    this.stopIdle();
    return new Promise((resolve) => {
      this.sprite.setTexture(this.pair.girlKeys.command);
      this.scene.tweens.add({
        targets: this.sprite,
        y: this.sprite.y - 3,
        duration: 200,
        yoyo: true,
        onComplete: () => resolve(),
      });
    });
  }

  /** После успешной команды — самодовольная поза. */
  playSmug(durationMs = 600): Promise<void> {
    this.stopIdle();
    return new Promise((resolve) => {
      this.sprite.setTexture(this.pair.girlKeys.smug);
      this.scene.time.delayedCall(durationMs, () => resolve());
    });
  }

  playBlush(): Promise<void> {
    this.stopIdle();
    return new Promise((resolve) => {
      const k = this.pair.girlKeys;
      let frame = 0;
      this.sprite.setTexture(k.blush1);
      const t = this.scene.time.addEvent({
        delay: 120,
        repeat: 3,
        callback: () => {
          frame++;
          this.sprite.setTexture(frame % 2 === 0 ? k.blush1 : k.blush2);
        },
      });
      this.scene.time.delayedCall(560, () => {
        t.remove();
        resolve();
      });
    });
  }

  startRun(): void {
    this.stopIdle();
    const k = this.pair.girlKeys;
    let frame = 0;
    this.sprite.setTexture(k.run1);
    this.idleTimer = this.scene.time.addEvent({
      delay: 120,
      loop: true,
      callback: () => {
        frame++;
        this.sprite.setTexture(frame % 2 === 0 ? k.run1 : k.run2);
      },
    });
  }
}
